import { withCriticalRetry } from "@utils/apiWrapper";
import { convertTopLevelKeysToSnakeCase } from "@utils/common";
import axios from "axios";
import { API_BASE_URL } from "initializers/constants";
const create = (payload) => {
    const snakeCasedPayload = convertTopLevelKeysToSnakeCase(payload);
    return withCriticalRetry(() => axios.post(`${API_BASE_URL}/reporter/runs`, { run: snakeCasedPayload }, { skipSnakeCaseConversion: true }), { additionalRetryStatusCodes: [422] });
};
const update = (ciBuildId, payload) => withCriticalRetry(() => axios.put(`${API_BASE_URL}/reporter/runs/${ciBuildId}`, {
    run: payload,
}), { additionalRetryStatusCodes: [422] });
const heartbeat = (ciBuildId) => axios.get(`${API_BASE_URL}/reporter/runs/${ciBuildId}/heartbeat`);
const runsApi = { create, update, heartbeat };
export default runsApi;
//# sourceMappingURL=runs.js.map